import React from 'react';
export function Footer() {
  return <footer className="bg-brand-dark border-t border-brand-muted/10 py-12 px-4 text-center" data-id="element-9">
      <div className="max-w-4xl mx-auto" data-id="element-10">
        <h4 className="text-brand-volt font-black text-2xl mb-4 tracking-widest" data-id="element-11">
          MEGA PACK TRAIL RUNNING
        </h4>
        <p className="text-gray-500 text-sm normal-case mb-8" data-id="element-12">
          Porque preparar clases de trail running no debería robarte tus noches,
          tus domingos ni tu tiempo libre.
        </p>
        <div className="text-gray-600 text-xs normal-case" data-id="element-13">
          &copy; {new Date().getFullYear()} Stock Digital™. Todos los derechos
          reservados.
        </div>
      </div>
    </footer>;
}